import { render } from "./HowWeWork.vue?vue&type=template&id=28d590ee"
import script from "./HowWeWork.vue?vue&type=script&lang=js"
export * from "./HowWeWork.vue?vue&type=script&lang=js"

import "./HowWeWork.vue?vue&type=style&index=0&id=28d590ee&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__